import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { View, FlatList, useWindowDimensions, StyleSheet } from 'react-native';
import { ActivityIndicator, Card } from 'react-native-paper';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomButton from '../../../components/CustomButton';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../styles/commonStyles';
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';
import { useTableHelper } from '../../../hooks/useTableHelper';
import CustomControlledCheckbox from '../../../components/ControlledComponents/CustomControlledCheckbox';
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledDropdown from '../../../components/ControlledComponents/CustomControlledDropdown';
import CustomControlledDropdownWithSearch from '../../../components/ControlledComponents/CustomControlledDropdownWithSearch';
import HRAdminPromotionHistory from './HRAdminPromotionHistory';


const FlatListViewEmplDepts = React.memo(({ item, styles, t, convertDate, handleDelete,
    selectedCompany, dropdowns, getDropdownValues, renameKeysInOptions,
    modal, control, watch, setValue, ActivityIndicator, index, setShowPromHist, insertData, width, employmentTabData
}) => {

    //#region Variables
    const [showAdditionalInformation, setShowAdditionalInformation] = useState(true);
    const [showCalendar, setShowCalendar] = useState(false);
    const [doaCalendar, setDoaCalendar] = useState([]);
    const [dotCalendar, setDotCalendar] = useState([]);
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [L4, setL4] = useState([]);
    const [L5, setL5] = useState([]);
    const [L6, setL6] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pressed, setPressed] = useState();
    //#endregion

    //#region UseEffects
    useEffect(() => {
        const subscription = watch((value, { name }) => {
            const data = value[item.rowguid];
            if (!data) return;
            if (name === `${item?.rowguid}.dept`) {
                fetchDropdownValues('L4', { sFilt1: selectedCompany?.code, sFilt2: data?.dept, sFilt3: "" });
                setL5([]); // Reset L5 when dept changes
                setL6([]); // Reset L6 when dept changes
            } else if (name === `${item?.rowguid}.L4`) {
                fetchDropdownValues('L5', { sFilt1: selectedCompany?.code, sFilt2: data?.dept, sFilt3: data?.L4 });
                setL6([]); // Reset L6 when L4 changes
            } else if (name === `${item?.rowguid}.L5`) {
                fetchDropdownValues('L6', { sFilt1: selectedCompany?.code, sFilt2: data?.dept, sFilt3: data?.L4, sFilt4: data?.L5 });
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, index, selectedCompany, fetchDropdownValues, setL5, setL6]);

    useEffect(() => {
        fetchDropdownValues('L4', { sFilt1: selectedCompany?.code, sFilt2: item?.dept, sFilt3: "" });
        setL5([]); // Reset L5 when dept changes
        setL6([]); // Reset L6 when dept changes
    }, [item?.dept]);

    useEffect(() => {
        fetchDropdownValues('L5', { sFilt1: selectedCompany?.code, sFilt2: item?.dept, sFilt3: item?.L4 });
        setL6([]); // Reset L6 when dept changes
    }, [item?.L4]);

    useEffect(() => {
        fetchDropdownValues('L6', { sFilt1: selectedCompany?.code, sFilt2: item?.dept, sFilt3: item?.L4, sFilt4: item?.L5 });
    }, [item?.L5]);

    useEffect(() => {
        const dateToSet = doaCalendar?.startDate ? convertDate(doaCalendar.startDate) : '';
        setValue(`${item?.rowguid}.doa`, dateToSet);
    }, [doaCalendar]);

    useEffect(() => {
        const dateToSet = dotCalendar?.startDate ? convertDate(dotCalendar.startDate) : '';
        setValue(`${item?.rowguid}.dot`, dateToSet);
    }, [dotCalendar]);

    useEffect(() => {
        let doa = item?.doa;
        if (doa) {
            setDoaCalendar({ startDate: doa });
        } else {
            setDoaCalendar({ startDate: '' });
        }

        let dot = item?.dot;
        if (dot) {
            setDotCalendar({ startDate: dot });
        } else {
            setDotCalendar({ startDate: '' });
        }
    }, [])
    //#endregion

    //#region Handlers
    const onShowCalendarPress = (btn) => {
        if (pressed === btn) {
            setPressed(null);
            setCalendarVisible(false);
            setShowCalendar(!showCalendar);
        }
        else {
            setPressed(btn);
            setCalendarVisible(true);
            setShowCalendar(true);
        }
    }

    const onShowAdditionalLocationInfoPress = () => {
        setShowAdditionalInformation(!showAdditionalInformation)
    }
    //#endregion

    //#region Getters
    const fetchDropdownValues = (level, filters) => {
        setIsLoading(true);
        const sParams = [{ [level]: filters }];
        getDropdownValues(sParams).then((res) => {
            let renamedOptions;
            if (res.length <= 0)
                renamedOptions = [];
            else renamedOptions = renameKeysInOptions(res?.[level]);
            if (level === 'L4') setL4(renamedOptions);
            if (level === 'L5') setL5(renamedOptions);
            if (level === 'L6') setL6(renamedOptions);
            setIsLoading(false);
        });
    };
    //#endregion

    //#region Promotion History
    const renderPromotionHist = () => {
        setShowPromHist({ show: true, item: item });
    }
    //#endregion

    //#region Calendar
    const renderCalendar = () => {
        return (
            <SafeAreaView style={styles.secondLine}>
                {/* calendar view */}
                <View style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 10,
                    borderWidth: 0,
                    borderColor: colors.border_card,
                }}>
                    <CustomCalendar
                        calendarType={'RangePicker'}
                        setRange={pressed === 'doa' ? setDoaCalendar : setDotCalendar}
                        range={pressed === 'doa' ? doaCalendar : dotCalendar}
                        allowSingleDate={true}
                        startingYear={1990}
                    />
                </View>
            </SafeAreaView>
        )
    }
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <ActivityIndicator animating={true} />
        )
    //#endregion

    return (
        <SafeAreaView>
            <SafeAreaView style={styles.row}>
                <SafeAreaView style={[styles.dropdownView]}>
                    <SafeAreaView>
                        <CustomLabel value={t(`common:department`)} type='SUBTITLENOFLEX' />
                        <CustomControlledDropdownWithSearch
                            control={control}
                            /*TODO: remove disable when drop down is fixed with additional info closed*/
                            disabled={showAdditionalInformation ? false : true}
                            name={`${item.rowguid}.dept`}
                            type="EDIT_EMPLOYEE"
                            options={dropdowns?.departmentServLineFunc}
                            setValue={setValue}
                        />
                    </SafeAreaView>
                </SafeAreaView>

                <SafeAreaView style={[{ flex: 1, flexDirection: width < 1300 ? 'column' : 'row' }]}>
                    <SafeAreaView>
                        <SafeAreaView style={[styles.containerCheck]}>
                            <View style={[styles.itemCheck]}>
                                <CustomControlledCheckbox
                                    control={control}
                                    name={`${item.rowguid}.isPrimary`}
                                />
                                <CustomLabel value="Primary" type='SUBTITLENOFLEX' />
                            </View>
                        </SafeAreaView>
                        <CustomButton
                            iconName={!showAdditionalInformation ? 'chevron-forward-outline' : 'chevron-down-outline'}
                            onPress={() => {
                                onShowAdditionalLocationInfoPress()
                            }}
                            text={t('common:additionalInfos')}
                            show='PART'
                            type='PART'
                            textTop='0'
                            sz={30} />
                    </SafeAreaView>

                    <CustomButton
                        iconName={"trash-outline"}
                        onPress={() => {
                            handleDelete(item, index, 'rowguid', modal)
                        }}
                        show='PART'
                        type='PART'
                        textTop='0'
                        sz={30} />

                </SafeAreaView>
            </SafeAreaView>
            {showAdditionalInformation &&
                <SafeAreaView style={[{ zIndex: -1 }]}>
                    <SafeAreaView style={styles.row}>
                        <SafeAreaView style={[styles.item]}>
                            <CustomLabel value={t(`common:jobTitle`)} type='SUBTITLENOFLEX' />
                            <CustomControlledDropdown
                                multipleSelect={true}
                                control={control}
                                name={`${item.rowguid}.jobTitle`}
                                type="EDIT_EMPLOYEE"
                                options={dropdowns?.jobTitle}
                                setValue={setValue}
                            />
                        </SafeAreaView>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:employmentContext`)} type='SUBTITLENOFLEX' />
                                <CustomControlledDropdown
                                    multipleSelect={true}
                                    control={control}
                                    name={`${item.rowguid}.employmentContext`}
                                    type="EDIT_EMPLOYEE"
                                    options={dropdowns?.employmentContext}
                                    setValue={setValue}
                                />
                            </SafeAreaView>
                        </View>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:seniority`)} type='SUBTITLENOFLEX' />
                                <CustomControlledDropdown
                                    multipleSelect={true}
                                    control={control}
                                    // this is disabled because it is edited in Promotion history 
                                    disabled={true}
                                    name={`${item.rowguid}.seniority`}
                                    type="EDIT_EMPLOYEE"
                                    options={dropdowns?.hcode}
                                    setValue={setValue}
                                />
                            </SafeAreaView>
                        </View>
                        {!insertData.includes(item?.rowguid) &&
                            <CustomButton
                                iconName={"analytics-outline"}
                                onPress={() => {
                                    renderPromotionHist();
                                }}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                        }
                    </SafeAreaView>
                    <SafeAreaView style={styles.row}>
                        {/* <SafeAreaView style={styles.item}>
                                    <CustomLabel value={t('common:allocation')} type='SUBTITLENOFLEX' />
                                    <CustomControlledInput
                                        name={`${item.rowguid}.allocation`}
                                        control={control}
                                        editable={true}
                                        type='EDIT_EMPLOYEE'
                                    />
                                </SafeAreaView> */}
                        <SafeAreaView style={styles.item}>
                            <CustomLabel value={t('common:company')} type='SUBTITLENOFLEX' />
                            <CustomControlledInput
                                defaultValue={selectedCompany?.description}
                                name={`${item.rowguid}.company`}
                                control={control}
                                editable={false}
                                type='MAININPUT'
                            />
                        </SafeAreaView>
                        <SafeAreaView style={[styles.row, { marginLeft: 10 }]}>
                            <SafeAreaView style={styles.item}>
                                <CustomLabel value={t(`common:dateOfAppointment`)} type='SUBTITLENOFLEX' />
                                <CustomControlledInput
                                    name={`${item.rowguid}.doa`}
                                    control={control}
                                    editable={false}
                                    type='MAININPUT'
                                    rules={{
                                        required: t('common:doaReqMess'),
                                    }}
                                />
                            </SafeAreaView>
                            <Ionicons
                                name={pressed === 'doa' ? "calendar" : "calendar-outline"}
                                style={styles.icons}
                                onPress={() => onShowCalendarPress('doa')}
                            />
                        </SafeAreaView>
                        <SafeAreaView style={[styles.row, { marginLeft: 10 }]}>
                            <SafeAreaView style={styles.item}>
                                <CustomLabel value={t(`common:endDate`)} type='SUBTITLENOFLEX' />
                                <CustomControlledInput
                                    name={`${item.rowguid}.dot`}
                                    control={control}
                                    editable={false}
                                    type='MAININPUT'
                                />
                            </SafeAreaView>
                            <Ionicons
                                name={pressed === 'dot' ? "calendar" : "calendar-outline"}
                                style={styles.icons}
                                onPress={() => onShowCalendarPress('dot')}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                    {(!employmentTabData?.L4?.isDisabled || !employmentTabData?.L5?.isDisabled || !employmentTabData?.L6?.isDisabled) && <SafeAreaView style={styles.row}>
                        {!employmentTabData?.L4?.isDisabled && <SafeAreaView style={styles.item}>
                            <CustomLabel value={t('common:L4')} type='SUBTITLENOFLEX' />
                            <CustomControlledDropdown
                                multipleSelect={true}
                                control={control}
                                name={`${item.rowguid}.L4`}
                                type="EDIT_EMPLOYEE"
                                options={L4}
                                setValue={setValue}
                            />
                        </SafeAreaView>
                        }
                        {!employmentTabData?.L5?.isDisabled && <SafeAreaView style={styles.item}>
                            <CustomLabel value={t('common:L5')} type='SUBTITLENOFLEX' />
                            <CustomControlledDropdown
                                multipleSelect={true}
                                control={control}
                                name={`${item.rowguid}.L5`}
                                type="MAININPUT"
                                options={L5}
                                setValue={setValue}
                            />
                        </SafeAreaView>
                        }
                        {!employmentTabData?.L6?.isDisabled && <SafeAreaView style={styles.item}>
                            <CustomLabel value={t('common:L6')} type='SUBTITLENOFLEX' />
                            <CustomControlledDropdown
                                multipleSelect={true}
                                control={control}
                                name={`${item.rowguid}.L6`}
                                type="EDIT_EMPLOYEE"
                                options={L6}
                                setValue={setValue}
                            />

                        </SafeAreaView>
                        }
                    </SafeAreaView>
                    }
                    <SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <CustomLabel value="Comments" type='SUBTITLENOFLEX' />
                            <CustomControlledInput
                                name={`${item.rowguid}.comments`}
                                control={control}
                                editable={true}
                                type='MAININPUT'
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            }
            {showCalendar && calendarVisible &&
                renderCalendar()
            }
        </SafeAreaView>

    )
})


const HRAdminEmplDepts = ({ props }) => {

    //#region Variables
    const { selectedEmployee, convertDate, flatlistEditPress,
        modal, t, getDropdownValues, dropdowns, employmentTabData,
        renameKeysInOptions, selectedCompany, modalVisible, setModalVisible,
    } = props;
    const { width, height } = useWindowDimensions();
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, width);
    const [changes, setChanges] = useState([]);
    const { getEmplDepts, updateEmplDepts, insertEmplDepts, deleteEmplDepts, getLimitedData } = useHRAdminEmployees();
    const [emplDepts, setEmplDepts] = useState([]);
    const { handleCancelChanges, rowAdd, rowDelete } = useTableHelper();
    const [deletedItems, setDeletedItems] = useState([]);
    const [originalEmplDepts, setOriginalEmplDepts] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [insertData, setInsertData] = useState([]);
    const { control, handleSubmit, formState: { errors }, getValues, setValue, watch, unregister, register } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);
    const [showPromHist, setShowPromHist] = useState({ show: false, item: null });
    const ref = useRef(null);
    //#endregion

    //#region UseEffects
    useEffect(() => {
        getEmplDepts(selectedEmployee?.employeeID).then((res) => {
            let empldepts = res?.data;
            empldepts.forEach(dept => {
                dept['doa'] = dept?.doa?.split('T')[0];
                dept['dot'] = dept?.dot?.split('T')[0];
                dept['company'] = selectedCompany?.description;
            });
            setEmplDepts(empldepts);
            setOriginalEmplDepts(empldepts);
            empldepts.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    setValue(`${item.rowguid}.${key}`, item[key]);
                });
            });
        })
    }, [])


    const reloadEmplDepts = () => {
        setIsLoading(true);
        getEmplDepts(selectedEmployee?.employeeID).then((res) => {
            let empldepts = res?.data;
            empldepts.forEach(dept => {
                dept['doa'] = dept?.doa?.split('T')[0];
                dept['dot'] = dept?.dot?.split('T')[0];
                dept['company'] = selectedCompany?.description;
            });
            setEmplDepts(empldepts);
            setOriginalEmplDepts(empldepts);
            empldepts.forEach((item) => {
                Object.keys(item).forEach(key => {
                    setValue(`${item.rowguid}.${key}`, item[key]);
                });
            });
            setIsLoading(false);
        });
    };

    useEffect(() => {
        if (state) {
            setShowState(true);
            const timer = setTimeout(() => {
                setShowState(false);
                setState(null);
            }, 10000);
            return () => {
                clearTimeout(timer)
                setState(null);
            };
        }
    }, [state]);

    useEffect(() => {
        if (emplDepts.length <= 0) return;
        let item = emplDepts[0];
        Object.keys(item).forEach(key => {
            if (key === 'doa' || key === 'dot')
                register(`${item.rowguid}.${key}.startDate`);
            else
                register(`${item.rowguid}.${key}`);

        });
    }, [emplDepts, setValue]);
    //#endregion

    //#region Handlers
    const handleAddPress = () => {
        let exceptions = ["doa", "dept", "jobTitle", "employmentContext", "seniority", "dot"];
        rowAdd(emplDepts, setEmplDepts, exceptions, [], ref, t, [], [], changes, setChanges, insertData, setInsertData, id = 'rowguid');
    };

    const handleRemovePress = () => {
        handleCancelChanges(setEmplDepts, originalEmplDepts, setDeletedItems, setChanges, setDuplicates);
    };

    const handleDelete = (item, index, attribute, modal) => {
        rowDelete(item, index, attribute, changes, setChanges, emplDepts, setEmplDepts, setDeletedItems, ref);
        unregister(`items.${item.rowguid}`);
    }
    //#endregion

    //#region Modal - Specific Functions
    const closeModal = () => {
        props.onClose();
        setModalVisible(!modalVisible);
    }
    //#endregion

    //#region Submit
    const onSubmit = data => {
        let remainingObjects = [];
        let hasMultPrimaries = false;

        let isCorrect = isCorrectInput(data);
        if (!isCorrect?.isCorrect) {
            return;
        }

        for (const key in data) {
            data[key].doa = data[key].doa?.startDate ?? data[key].doa ?? null;
            data[key].dot = data[key].dot?.startDate ?? data[key].dot ?? null;
            if (data[key]['isPrimary'])
                if (hasMultPrimaries) {
                    setState('multiplePrimariesEmplDepts');
                    return;
                }
                else if (!hasMultPrimaries)
                    hasMultPrimaries = true;
            if (data[key]?.dot && data[key].dot < data[key].doa) {
                setState('dotBeforeDoa');
                return;
            }
            if (!insertData.includes(key) && !deletedItems.includes(key)) {
                remainingObjects.push(data[key])
            }
        }

        if (!hasMultPrimaries) // if hasmultprimaries = false, that means the user has not assigned any primary dept
        {
            setState('multiplePrimariesEmplDepts');
            return;
        }

        const insertObjects = findObjects(data, insertData);
        submitData(insertObjects, remainingObjects, deletedItems)
    };


    const submitData = async (insertData, updateData, deleteData) => {
        let newPromises = [];
        let deleteSucc = true;
        let updateSucc = true;
        let insertSucc = true;
        let employeeid = selectedEmployee?.employeeID;
        setIsLoading(true);
        setState('saving');
        if (insertData.length > 0)
            newPromises.push(
                insertEmplDepts(insertData, employeeid).then((res) => {
                    if (res?.status === 200) {
                        insertSucc = true;
                    } else {
                        insertSucc = false;
                    }
                }).catch((e) => { console.error("Insert failed: ", e) })
            )
        if (deleteData.length > 0)
            newPromises.push(
                deleteEmplDepts(deleteData, employeeid).then((res) => {
                    if (res?.status === 200) {
                        deleteSucc = true;
                    } else {
                        deleteSucc = false;
                    }
                }).catch((e) => { console.error("Delete failed: ", e) })
            )
        if (updateData.length > 0)
            newPromises.push(
                updateEmplDepts(updateData, employeeid).then((res) => {
                    if (res?.status === 200) {
                        updateSucc = true;
                    } else {
                        updateSucc = false;
                    }
                }).catch((e) => { console.error("Update failed: ", e) })
            )
        try {
            await Promise.all(newPromises).then(() => {
                if (deleteSucc && updateSucc && insertSucc) {
                    setState('allOperationsSuccMess');
                } else {
                    // Handle failure states as needed
                    if (!updateSucc) setState('updateFailed');
                    else if (!deleteSucc) setState('deleteFailed');
                    else setState('issueMessage');
                }
            });
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    }
    //#endregion

    //#region Helpers
    const findObjects = (mainObject, rowguids) => {
        return rowguids.map(rowguid => {
            const innerObject = mainObject[rowguid];
            if (innerObject) {
                return {
                    ...innerObject, rowguid,
                    employeeID: innerObject.employeeID ?? selectedEmployee?.employeeID
                };
            }
            return null;
        }).filter(item => item !== null);
    };

    const isAllocationMoreThanHundred = (data) => {
        let sum = 0;
        Object.values(data).forEach(row => {
            let allocation = 0;
            if (row?.allocation) {
                allocation = Number(row.allocation); // Ensure allocation is a number
            }
            sum += allocation;
        });
        if (sum > 100)
            return true;
    }

    const isCorrectInput = (data) => {
        if (isAllocationMoreThanHundred(data))
            return { isCorrect: false, message: "The sum of allocation %s for active departments must be 100. Your changes will not be saved." };
        Object.values(data).forEach(row => {
            row["doa"] = row?.doa?.startDate ?? row?.doa ?? null;
            row["dot"] = row?.dot?.startDate ?? row?.dot ?? null;;
            row["company"] = selectedCompany?.code;
        });
        return { isCorrect: true };
    };
    //#endregion

    const renderEmplDepts = ({ item, index }) => {
        return (
            <Card style={[common.cardstyle]}>
                <Card.Content>
                    <FlatListViewEmplDepts
                        styles={styles}
                        control={control}
                        item={item}
                        index={index}
                        convertDate={convertDate}
                        handleDelete={handleDelete}
                        dropdowns={dropdowns}
                        getDropdownValues={getDropdownValues}
                        getValues={getValues}
                        watch={watch}
                        renameKeysInOptions={renameKeysInOptions}
                        selectedCompany={selectedCompany}
                        modal={modal}
                        setValue={setValue}
                        ActivityIndicator={ActivityIndicator}
                        setShowPromHist={setShowPromHist}
                        insertData={insertData}
                        employmentTabData={employmentTabData}
                        width={width}
                        t={t}
                    />
                </Card.Content>
            </Card>
        )
    }

    return (
        (!showPromHist['show'] ?
            <>
                <View style={styles.iconRow}>
                    {modal?.allowsAddDelete ? (
                        <View style={styles.leftIcons}>
                            <Ionicons
                                name={"add-circle-outline"}
                                style={styles.icon}
                                onPress={handleAddPress}
                            />
                            <Ionicons
                                name={"remove-circle-outline"}
                                style={styles.icon}
                                onPress={handleRemovePress}
                            />
                        </View>
                    ) : (
                        <View style={styles.leftIcons}></View>
                    )}
                    <View style={[styles.rightIcon, { flexDirection: 'row' }]}>
                        {state && showState && <CustomLabel
                            value={`${t('common:state')}: ${t(`common:${state}`)}`}
                            type='EDIT_EMPLOYEE_STATE'
                        />}
                        <Ionicons
                            name={"close-circle-outline"}
                            style={styles.icon}
                            onPress={closeModal}
                        />
                    </View>
                </View>
                <FlatList
                    style={[{ height: height / 2 }, { flexGrow: 0 }]}
                    data={emplDepts}
                    keyExtractor={(item) => `${item?.rowguid}`}
                    renderItem={renderEmplDepts}
                    scrollEnabled={true}
                    refreshing={isLoading}
                    ref={ref}
                    initialNumToRender={10}
                    ListHeaderComponent={
                        <CustomLabel
                            value={`${selectedEmployee?.name}'s ${t(`common:${modal?.title}`)}`}
                            type='SUBTITLE'
                        />
                    }
                    ListEmptyComponent={
                        isLoading ? (
                            <ActivityIndicator animating={true} color={colors.blue} />
                        ) : (
                            <CustomLabel
                                value={t("common:emplDeptsLoadingPreview")}
                                type="NO_BRANCHES"
                            />
                        )
                    }
                />
                <View style={[styles.functionalityButtons]}>
                    <CustomButton
                        text={t('common:saveChanges')}
                        onPress={handleSubmit(onSubmit)}
                        type='BUTTON_SAVE'
                        isGradient={true}
                        textTop='0'
                        sz={15}
                    />
                </View>
            </>
            :
            <HRAdminPromotionHistory
                props={{
                    selectedCompany: selectedCompany,
                    emplCompany: props.emplCompany,
                    selectedEmployee: selectedEmployee,
                    rowguid: showPromHist['item']['rowguid'],
                    dept: showPromHist['item']['dept'],
                    doa: showPromHist['item']['doa'],
                    selectedEmployee: selectedEmployee,
                    convertDate: convertDate,
                    handleDelete: handleDelete,
                    flatlistEditPress: flatlistEditPress,
                    isLoading: isLoading,
                    modal: modal,
                    t: t,
                    styles: styles,
                    common: common,
                    getDropdownValues: getDropdownValues,
                    dropdowns: dropdowns,
                    getValues: getValues,
                    employmentTabData: employmentTabData,
                    watch: watch,
                    emplDepts: emplDepts,
                    setEmplDepts: setEmplDepts,
                    renameKeysInOptions: renameKeysInOptions,
                    selectedCompany: selectedCompany,
                    modalVisible: modalVisible,
                    setModalVisible: setModalVisible,
                    setShowPromHist: setShowPromHist,
                    colors: colors,
                    onPromotionHistoryUpdated: reloadEmplDepts,
                    onClose: props.onClose
                }}
            />

        )
    );
};
const makeStyles = (colors, width) =>
    StyleSheet.create({
        mainView: {
            flex: 1,
        },
        row: {
            flex: 1,
            marginVertical: 5,
            flexDirection: 'row'
        },
        dropDownView: {
            flexDirection: 'row',
            flex: 6,
            alignSelf: "center",
            justifyContent: "center",
        },
        iconRow: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 10,
        },
        functionalityButtons: {
            justifyContent: 'flex-end',
        },
        rightIcon: {
            alignItems: 'flex-end',
        },
        item: {
            flex: 1,
            justifyContent: "center",
            marginRight: 6
        },
        icon: {
            fontSize: 30,
            color: 'black',
            marginHorizontal: 5,
        },
        icons: {
            fontSize: 24,
            marginHorizontal: 10,
        },
        iconRow: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 10,
        },
        leftIcons: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        containerCheck: {
            marginHorizontal: 5,
            alignItems: 'flex-end'
        },
        itemCheck: {
            flexDirection: 'row',
        },
    })
export default HRAdminEmplDepts;